/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Qrcodevalidityinminutes4Inputs */

const en__field_qrcodevalidityinminutes4 = /** @type {(inputs: _Field_Qrcodevalidityinminutes4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validity duration of qr code (in minutes)`)
};

const de__field_qrcodevalidityinminutes4 = /** @type {(inputs: _Field_Qrcodevalidityinminutes4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gültigskeitsdauer QR-Code (in Minuten)`)
};

/**
* | output |
* | --- |
* | "Validity duration of qr code (in minutes)" |
*
* @param {_Field_Qrcodevalidityinminutes4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_qrcodevalidityinminutes4 = /** @type {((inputs?: _Field_Qrcodevalidityinminutes4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Qrcodevalidityinminutes4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_qrcodevalidityinminutes4(inputs)
	return de__field_qrcodevalidityinminutes4(inputs)
});
export { _field_qrcodevalidityinminutes4 as "_field_qrCodeValidityInMinutes" }